import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeleteEmspUserOcpiTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/delete-emsp-user-ocpi-token.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { useDeleteEmspBoEmspUserOcpiTokenContext } from '../../emsp-bo-emsp-user.context';
import { EmspBoEmspUserOcpiTokenDeleteFormStep1Controller } from '../emsp-bo-emsp-user-ocpi-token-delete-form-step-1/emsp-bo-emsp-user-ocpi-token-delete-form-step-1.controller';

// /////////////////////////////////////////////////////////////////////////////

interface EmspBoEmspUserOcpiTokenDeleteFormControllerProps {
  onError: SubmitErrorHandler<DeleteEmspUserOcpiTokenModel>;
  onSubmit: SubmitHandlerWithDirtyFields<DeleteEmspUserOcpiTokenModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoEmspUserOcpiTokenDeleteFormController = (
  props: EmspBoEmspUserOcpiTokenDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteEmspBoEmspUserOcpiTokenContext();

  return (
    <MultiStepFormProvider<DeleteEmspUserOcpiTokenModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['userId', 'tokenId'],
          component: <EmspBoEmspUserOcpiTokenDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
